// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.25 3.938c0-.52.418-.938.938-.938h15.625c.519 0 .937.418.937.938 0 .519-.418.937-.937.937H2.188a.935.935 0 0 1-.938-.937m2.5 6.25c0-.52.418-.938.938-.938h10.625c.519 0 .937.418.937.938 0 .519-.418.937-.937.937H4.688a.935.935 0 0 1-.938-.937m8.75 6.25c0 .519-.418.937-.937.937H8.437a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938h3.124c.52 0 .938.418.938.938"
  }));
};
